import clsx from 'clsx';

import { Icon } from '@gitbook/spine-icons';

import { Description } from '../Description';
import { Heading } from '../Heading';
import { Skeleton, TextSkeleton } from '../Skeleton';
import { Card } from './Card';

export function CardSkeleton(props: { title?: string; description?: string; className?: string }) {
    const { title, description, className } = props;
    return (
        <Card className={clsx('flex h-full w-full flex-col gap-4 p-4', className)}>
            <Skeleton shape="circle" className="size-10">
                <Icon.Integrations />
            </Skeleton>
            <Heading>
                <TextSkeleton className={title ? undefined : 'w-1/2'}>{title}</TextSkeleton>
            </Heading>
            <Description>
                <TextSkeleton className={description ? undefined : 'w-full'}>
                    {description}
                </TextSkeleton>
            </Description>
        </Card>
    );
}
